"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SRFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_213)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_213`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 -0.00012207H30V24.0002H-6V-0.00012207Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 7.82599H30V16.1741H-6V7.82599Z",
					fill: "#A2001D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 18.7825H30V24.0002H-6V18.7825ZM-6 -0.00012207H30V5.21756H-6V-0.00012207Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.0521 9.32837L12.7152 11.3689H14.861L13.125 12.6302L13.7881 14.6709L12.0521 13.4097L10.3162 14.6709L10.9793 12.6302L9.24329 11.3689H11.3891L12.0521 9.32837Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_213`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SRFlag };
